// @ts-nocheck
import React from 'react';

const Header = ({
                    title,
                    subtitle,
                    eyebrow,
                    description,
                    actions,
                    compact = false,
                }) => {
    return (
        <header className={compact ? 'mb-4' : 'mb-6'}>
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
                <div>
                    {eyebrow && (
                        <p className="mb-2 text-xs font-bold uppercase tracking-[0.24em] text-emerald-700">
                            {eyebrow}
                        </p>
                    )}

                    {title && (
                        <h1 className="text-3xl font-extrabold tracking-tight text-slate-950 md:text-4xl">
                            {title}
                        </h1>
                    )}

                    {subtitle && (
                        <h2 className="mt-2 text-lg font-medium text-emerald-700 md:text-xl">
                            {subtitle}
                        </h2>
                    )}

                    {description && (
                        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-500">
                            {description}
                        </p>
                    )}
                </div>

                {actions && (
                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                        {actions}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;